import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import modules from './modules';

Vue.use(Vuex);

const state = {
  auth: {
    token: localStorage.getItem('token') || '',
  },
};

const store = new Vuex.Store({
  state,
  getters,
  actions,
  modules,
  mutations,
  plugins: [createPersistedState({
    key: 'sparkinter',
  })],
});

if (module.hot) {
  module.hot.accept([
    './getters',
    './actions',
    './mutations',
  ], () => {
    store.hotUpdate({
      getters: require('./getters'),
      actions: require('./actions'),
      mutations: require('./mutations'),
    });
  });
}

export default store;
